// Small typographic building blocks for section headers.
export const Eyebrow = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-1.5 w-1.5 bg-kv-royal kv-node rounded-full" aria-hidden />
    <span className="font-mono text-xs uppercase tracking-[0.22em] text-kv-steel">
      {children}
    </span>
  </div>
);

export const SectionHeading = ({ children, className = "" }) => (
  <h2 className={`font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.05] text-kv-off text-balance ${className}`}>
    {children}
  </h2>
);

export const Lead = ({ children, className = "" }) => (
  <p className={`font-body text-base md:text-lg leading-relaxed text-kv-grey ${className}`}>
    {children}
  </p>
);
